<script>
  // # # # # # # # # # # # # # # #
  //
  //  Ariel Horizontal Logo
  //
  // # # # # # # # # # # # # # # #
</script>

<style lang="scss">
  svg {
    display: block;
    height: 20px;
  }
</style>

<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 183.1 39.78">
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
      .cls-2 {
        clip-path: url(#clip-path);
      }
      .cls-3 {
        fill: #231f20;
      }
    </style>
    <clipPath id="clip-path" transform="translate(0 0)">
      <rect class="cls-1" width="183.1" height="39.78" />
    </clipPath>
  </defs>
  <title>Asset 1</title>
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <g class="cls-2">
        <path
          class="cls-3"
          d="M64.83,6.85H76.45c4.6,0,8.78.64,8.78,5.3s-4.07,5.78-9.16,5.78H64.83ZM56.16,39.18h8.67V23.92H74c8.45,0,10.17,1.56,10.54,9.16a23.83,23.83,0,0,0,.86,6.1H94.7a21.1,21.1,0,0,1-1.18-6.69c-.42-7.17-1.12-11.14-10-11.51v-.11c5.94-.43,10.65-3.21,10.65-10C94.22,3.26,87.85.53,79.34.53H56.16Zm53.43,0V.53h-8.67V39.18ZM147.31.53H116.69V39.18h31.58V32.86H125.36V22.26H146.5V16H125.36V6.85h22Zm5.87,38.65H183.1V32.86H161.85V.53h-8.67Z"
          transform="translate(0 0)" />
        <path
          class="cls-3"
          d="M7.87,39.78c-2.63,0-4.64-.59-6-1.74A5.76,5.76,0,0,1,0,33.43C0,28,5.13,19.57,12.76,12.53,21.39,4.57,31.14,0,39.53,0c2.41,0,3.93.68,4.52,2,1.33,3-2.32,9.27-10.84,18.5a.34.34,0,1,1-.5-.47C40.79,11.3,44.59,5,43.41,2.3,43,1.23,41.64.69,39.53.69,31.32.69,21.73,5.19,13.22,13,5.73,20,.69,28.15.69,33.43a5.13,5.13,0,0,0,1.66,4.09c1.21,1,3.06,1.57,5.52,1.57,7.48,0,16.09-5.35,22-9.84a104.72,104.72,0,0,0,9.72-8.45c3.72-8,8-15.94,9.1-17.69C50,1.09,51.34-.07,52.32,0a1,1,0,0,1,.88.65c.65,1.49-.71,5.95-6.71,13.6a75.93,75.93,0,0,1-6.35,7l-.15.33C33.78,35,33.94,38,34.3,38.69a.36.36,0,0,0,.36.21c2.45,0,12-13.52,17.78-22.61a.34.34,0,0,1,.48-.1.33.33,0,0,1,.1.47c0,.06-3.68,5.77-7.72,11.4-8.25,11.53-10,11.53-10.64,11.53a1,1,0,0,1-1-.57c-1-1.85,1.69-9,5.09-16.5a105.13,105.13,0,0,1-8.51,7.28c-6,4.55-14.73,10-22.41,10M52.23.69c-.58,0-1.73.86-3,2.8S44.39,12.21,41,19.38a68.71,68.71,0,0,0,5-5.56C52.18,5.88,53,1.92,52.57.93a.34.34,0,0,0-.3-.24h0"
          transform="translate(0 0)" />
      </g>
    </g>
  </g>
</svg>
